<template>
  <div class="page-content" style="padding-top: 4rem">
    <div class="container-fluid">
      <InfoCard :infoData="this.infoDetails" :loading="this.loading" />
      <div class="row">
        <div class="col-lg-12">
          <div class="card" id="orderList">
            <div class="card-header border-0">
              <div class="d-flex align-items-center" style="text-align: left">
                <h5 class="card-title mb-0 flex-grow-1">All Bookings</h5>
                <div class="flex-shrink-0">
                  <button
                    type="button"
                    class="btn btn-info"
                    @click="expSetNow()"
                    fdprocessedid="1yahzs"
                  >
                    <i class="ri-download-line align-bottom me-1"></i> Export
                  </button>
                </div>
              </div>
            </div>
            <div
              class="card-body border border-dashed border-end-0 border-start-0"
            >
              <form>
                <div class="row g-3">
                  <div class="col-xxl-4 col-sm-6">
                    <div class="search-box">
                      <input
                        type="text"
                        class="form-control search"
                        placeholder="Enter Passenger Booking Phone Number"
                        v-model="primary_passenger_contact"
                        @keydown.enter.prevent
                        @input="fetchList(1)"
                      />
                      <i class="ri-search-line search-icon"></i>
                    </div>
                  </div>
                  <div class="col-xxl-4 col-sm-6">
                    <div class="search-box">
                      <input
                        type="text"
                        class="form-control search"
                        placeholder="Enter Booking Id"
                        v-model="search_key"
                        @keydown.enter.prevent
                        @input="fetchList(1)"
                      />
                      <i class="ri-search-line search-icon"></i>
                    </div>
                  </div>

                  <div
                    class="col-xxl-2 col-sm-8"
                    v-if="ldata != null && ldata.role == 'superadmin'"
                  >
                    <div>
                      <select
                        class="form-control"
                        name="choices-single-default"
                        id="idStatus"
                        v-model="search_sort_by"
                        @change="fetchList(1)"
                      >
                        <option value="" selected>Sort By</option>
                        <template
                          v-for="(role, index) in sortOptions"
                          :key="index"
                        >
                          <option :value="role.value">{{ role.label }}</option>
                        </template>
                      </select>
                    </div>
                  </div>

                  <div
                    class="col-xxl-2 col-sm-8"
                    v-if="ldata != null && ldata.role === 'superadmin'"
                  >
                    <div>
                      <select
                        class="form-control"
                        name="choices-single-default"
                        id="idStatus"
                        v-model="booking_status"
                        @change="fetchList(1)"
                      >
                        <option value="" selected>Filter</option>
                        <template
                          v-for="(role, index) in filterOptions"
                          :key="index"
                        >
                          <option :value="role.value">{{ role.label }}</option>
                        </template>
                      </select>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div class="card-body pt-0">
              <div class="mt-5">
                <div class="table-responsive table-card mb-1">
                  <div class="noresult" v-if="loading">
                    <rb-loading-table />
                  </div>
                  <div v-else>
                    <rb-data-table
                      title="booking"
                      :ldata="ldata"
                      :headers="headers"
                      :tableData="formattedBookings"
                      @edit="viewBookings"
                    />
                  </div>
                </div>
                <div class="d-flex justify-content-end" v-if="!loading">
                  <div class="me-3">
                    <select
                      class="form-select w-auto"
                      v-model="limitProxy"
                      @change="fetchList(1)"
                    >
                      <template
                        v-for="(role, index) in paginationOptions"
                        :key="index"
                      >
                        <option :value="role">{{ role }}</option>
                      </template>
                    </select>
                  </div>
                  <div
                    class="pagination-wrap hstack gap-2"
                    style="display: flex"
                  >
                    <a
                      class="page-item pagination-prev px-4"
                      v-if="pageNo > 1"
                      @click="fetchList(pageNo - 1)"
                      href="javascript:void(0)"
                    >
                      <i class="ri-arrow-left-line"></i>
                    </a>
                    <ul
                      class="pagination listjs-pagination mb-0"
                      v-if="this.bookings.length > 0"
                    >
                      <li class="active">
                        <a class="page" href="javascript:void(0)">{{
                          pageNo
                        }}</a>
                      </li>
                      <li>
                        <a
                          v-if="this.bookings.length >= this.pageNo"
                          class="page"
                          href="javascript:void(0)"
                          @click="fetchList(pageNo + 1)"
                          >{{ pageNo + 1 }}</a
                        >
                      </li>
                    </ul>
                    <a
                      v-if="this.bookings.length >= this.pageNo"
                      class="page-item pagination-next px-4"
                      href="javascript:void(0)"
                      @click="fetchList(pageNo + 1)"
                    >
                      <i class="ri-arrow-right-line"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastNotification ref="toast" />
      </div>
      <loaderLoading v-if="overallLoading" />
    </div>
  </div>
</template>

<script>
import { getBookings, getBookingById } from "@/apis/booking";
import listMixin from "@/mixins/listMixin";
import { bookingInfoDetails } from "@/constants/infodetails";
import { bookingHeaders } from "@/constants/headers";
import { bookingSortOptions } from "@/constants/sort";
import { bookingFilterOptions } from "@/constants/filter";

export default {
  name: "bookingList",

  mixins: [listMixin],

  data() {
    return {
      bookings: [],

      search_key: "",
      primary_passenger_contact: "",
      search_sort_by: "",
      booking_status: "",

      filterOptions: bookingFilterOptions,
      sortOptions: bookingSortOptions,
      headers: bookingHeaders,
      infoDetails: bookingInfoDetails,
    };
  },
  methods: {
    async expSetNow() {
      const fields = [
        "TicketId",
        "CreatedAt",
        "CxPhoneNumber",
        "FromToLocation",
        "Passengers",
        "TotalPrice",
        "status",
      ];
      this.$exportCsv(this.formattedBookings, "Booking.csv", fields);
    },

    async fetchList(pageNo) {
      const response = await this.fetch(pageNo, getBookings, {
        booking_id: this.search_key,
        primary_passenger_contact: this.primary_passenger_contact,
        ascending: this.search_sort_by === "newest" ? false : true,
        sort_by: this.search_sort_by,
        booking_status: this.booking_status,
      });

      this.bookings = response.data;
      this.infoDetails[0].count = response?.total_booking;
      this.infoDetails[1].count = response?.total_revenue;
      this.infoDetails[2].count = response?.cancelledBooking;

      this.stopLoading();
    },

    async viewBookings(booking) {
      await this.update(
        getBookingById,
        booking.TicketId,
        "/ticket_details",
        "booking_id"
      );
    },
  },

  computed: {
    formattedBookings() {
      return this.bookings.map((booking) => ({
        TicketId: booking.booking_id,
        CreatedAt: booking.created_at
          ? new Date(booking.created_at).toLocaleString()
          : "N/A",
        CxPhoneNumber: booking.primary_passenger_contact,
        FromToLocation: `${booking.source}-${booking.destination}`,
        Passengers: booking.total_passengers,
        TotalPrice: booking.total_fare,
        webBooking:booking.web_booking,
        status: booking.booking_status,
      }));
    },
  },
};
</script>
